import { View } from "./View";

export interface IDatePickerProps {
  name: string;
  label: string;
  startDate?: string;
  endDate?: string;
  minDate?: string;
  maxDate?: string;
  setStartDate: (dtString: string) => void;
  setEndDate: (dtString: string) => void;
}

export const DateRangePicker = (props: IDatePickerProps) => {
  const { startDate, endDate, ...rest } = props;
  return <View startDate={startDate} endDate={endDate} {...rest} />;
};
